import {BffOAuth, BFFOAuthClient, OAuthConfig as BffOAuthConfig} from "@prowin/bff-oauth-client";

import {BFF_OAUTH_API_KEY, BFF_URL} from "../../const";
import {PiralOAuthCustomState} from "./types";

const oauthConfig: BffOAuthConfig = {
    bffUrl: BFF_URL,
    checkPath: '/bff/check',
    loginPath: '/bff/login',
    logoutPath: '/bff/logout',
    apiPath: '/bff/api',
    switchLoginPath: '/bff/switchlogin',
} as BffOAuthConfig

export async function bffInitOAuth() {
    return (new BffOAuth(oauthConfig, BFF_OAUTH_API_KEY))
        .initialize();
}


export function getOAuthValue(bffOauth: BFFOAuthClient): PiralOAuthCustomState {
    return {
        isTokenValid: bffOauth.initialized,
        isUserAuthenticated: bffOauth.initialized,
        accessToken: "",
        jwt: {},
        impersonated: bffOauth.user.impersonated,
        impersonator: bffOauth.user.impersonated ? bffOauth.user.name : null,
        customerNumber: bffOauth.user.customerNumber
    }
}